import styled, { css } from 'styled-components'

// Not doing anything fancy with vars etc here
// as this code is duplicated in portal fe

// Also deliberately avoiding using theme values like breakpoints, colours etc.
// as we don't actually want changes in the root theme to automatically apply here -
// that would mean the portal side would get out of sync
const tabItem = css`
  background-color: #ececec;
  border-color: transparent;
  border-radius: 8px 8px 0 0;
  border-style: solid;
  border-width: 2px 2px 0 2px;
  display: block;
  padding: 12px 0;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 0;
  font-weight: 400;
  color: #666;
  &:hover,
  &:focus {
    text-decoration: none;
    font-weight: 600;
    color: #000;
  }
  &:focus {
    outline: rgb(53, 173, 206) solid 2px;
    outline-offset: -2px;
  }
`

const tabItemSelected = css`
  background-color: #f5f5f5;
  border-color: #d0d0d0;
  color: #000;
  padding-top: 13px;
  z-index: 1;
  font-weight: 600;
`

export const TabOl = styled.ol`
  padding: 0 16px;
  position: relative;
  display: flex;
  &::after {
    background-color: #d0d0d0;
    bottom: 0;
    content: '';
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    z-index: 0;
  }
`

// NB: width: 50% below assumes only two tabs
export const TabLi = styled.li`
  width: 50%;
  @media screen and (min-width: 420px) {
    width: 170px;
  }
`

export const TabItemInactive = styled.a`
  text-decoration: none;
  ${tabItem}
`

export const TabItemActive = styled.span`
  ${tabItem}
  ${tabItemSelected}
`
